var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cancelBlack",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.461,
    height: 19.461,
    viewBox: "0 0 19.461 19.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    cx: 9.417,
    cy: 9.417,
    r: 9.417,
    fill: "#eaebef"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M9.73,0A9.73,9.73,0,1,1,0,9.73,9.73,9.73,0,0,1,9.73,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(0.314 0.314)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Page_1",
    "data-name": "Page 1",
    d: "M7.894,0,4.485,3.409,1.076,0,0,1.076,3.409,4.485,0,7.894,1.076,8.97,4.485,5.561,7.894,8.97,8.97,7.894,5.561,4.485,8.97,1.076Z",
    transform: "translate(4.932 4.932)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBlack);
export default __webpack_public_path__ + "static/media/cancelBlack.fe0e00b6144eaa4ce719f16f4df766c1.svg";
export { ForwardRef as ReactComponent };